import * as React from 'react'

const EntityBottomPanel = (props: { children: any }) => {
  return <div className='bottom-panel py2 px3 col-12 bg-light-grey7 border-box'>{props.children}</div>
}

export default EntityBottomPanel



// WEBPACK FOOTER //
// ./src/components/ui/entity/EntityBottomPanel.tsx